/* eslint no-undef: 0 */

import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { LINK_FINANCIAL_REPORTS } from '../../constants/link_constants'

const FinancialReportsListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.FINANCIAL_REPORTS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS1} type='button' onClick={store.downloadFinancialReports.bind(store)}>
        <span className='glyphicon glyphicon-download' />&nbsp;
        {store.__('Download selected report') +
          (store.cv.selection && store.cv.selection.length > 1 ? 's' : '')}
      </button>
    )
  }

  const filters = {
    id: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    client_id: {
      title: 'Client',
      component: (props) => (<SelectInput
        {...props}
        optionsrecord={store.options}
        labelattr='name'
        valueattr='id'
        optionsattr={'clients'} />)
    },
    contract_id: {
      title: 'Contract',
      component: (props) => (<SelectInput
        {...props}
        optionsrecord={store.options}
        valueattr='id'
        labelattr={i => (i.name + ' | ' + i.id)}
        optionsattr={'contracts'} />)
    },
    month: {
      title: 'Month',
      component: (props) => (<TextInput {...props} />)
    },
    year: {
      title: 'Year',
      component: (props) => (<TextInput {...props} />)
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_FINANCIAL_REPORTS)}
    fields={[
      (attr, row) => (<TextField attr={attr} val={row[attr]} />),
      (attr, row) => {
        return <TextField attr={attr} val={row.id} Component={({ text }) => (
          <a href={`${Conf.url}/financial_reports/report/${encodeURIComponent(row.s3path)}?token=${store.authToken}`}
            target='_blank' rel='noreferrer' title={row.s3path}><span className='glyphicon glyphicon-file' />
          </a>
        )} />
      },
      (attr, row) => {
        const clientTitle = store.options.has('clients') && store.options.get('clients').find(i => i.id === row[attr])
        const DetailLink = ({ text }) => (
          <a className='item-link-width' title={store.__('Click to open detail')} href='javascript:void(0)'
            onClick={() => store.goTo('entity_detail', { entityname: 'clients', id: row[attr] })}>
            <span className='glyphicon glyphicon-share-alt' />&nbsp;
            {clientTitle
              ? clientTitle.name
              : row[attr]}
          </a>
        )
        return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
      },
      (attr, row) => {
        const contractTitle = store.options.has('contracts') && store.options.get('contracts').find(i => i.id === row[attr])
        const DetailLink = ({ text }) => (
          <a className='item-link-width' title={store.__('Click to open detail')} href='javascript:void(0)'
            onClick={() => store.goTo('entity_detail', { entityname: 'contracts', id: row[attr] })}>
            <span className='glyphicon glyphicon-share-alt' />&nbsp;
            {contractTitle
              ? contractTitle.name
              : row[attr]}
          </a>
        )
        return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
      },
      (attr, row) => (<TextField attr={attr} val={row[attr]} />),
      (attr, row) => (<TextField attr={attr} val={row[attr]} />)
    ]}
    filters={() => Filters(store, filters)}
    batchActions={batchActions} />
  )
}
export default observer(FinancialReportsListView)
